export default __webpack_public_path__ + "static/testimonial-2-125b5e719349bd119d9c4ed99a7cae3e.jpg";